import React, { useState } from 'react';
const TABS = ['Overview', 'Specs', 'Options', 'PDFs / Downloads', 'Compatibility / USPS Notes', 'Reviews'];
const SPECS: [string, string][] = [['Total Tenant Doors', '20'], ['Tenant Door Height', '3.00"'], ['Total Parcel Lockers', '2'], ['Height', '72 1/16"'], ['Width', '32 11/16"'], ['Depth', '18"']];
export function ProductDescription() {
  const [activeTab, setActiveTab] = useState('Overview');
  return <div className="mt-16 border-t border-brand-border pt-12" data-id="element-660">
      {/* Tabs Header */}
      <div className="flex overflow-x-auto hide-scrollbar border-b border-brand-border mb-8" role="tablist" data-id="element-661">
        {TABS.map(tab => <button key={tab} type="button" role="tab" aria-selected={activeTab === tab} onClick={() => setActiveTab(tab)} className={`px-6 py-3 text-sm font-bold whitespace-nowrap border-b-2 transition-colors ${activeTab === tab ? 'border-brand-maroon text-brand-maroon' : 'border-transparent text-gray-500 hover:text-brand-charcoal hover:border-gray-300'}`} data-id="element-662">
            {tab}
          </button>)}
      </div>

      {/* Tab Content */}
      <div className="max-w-none" data-id="element-663">
        {activeTab === 'Overview' && <div className="prose max-w-none text-gray-700 leading-relaxed" data-id="element-664">
            <p data-id="element-665">
              The Depot is a freestanding solution that provides flexibility to
              install STD-4C wall-mounted mailboxes in a standalone cabinet.
              This option is designed for private delivery applications and is
              not approved for USPS Delivery.
            </p>
          </div>}

        {activeTab === 'Specs' && <div className="bg-white rounded-xl border border-brand-border overflow-hidden" data-id="element-666">
            <table className="w-full text-sm text-left" data-id="element-667">
              <tbody className="divide-y divide-brand-border" data-id="element-668">
                {SPECS.map(([label, value], i) => <tr key={label} className={i % 2 === 0 ? 'bg-brand-cream/30' : ''} data-id="element-669">
                    <th className="px-6 py-4 font-bold text-brand-charcoal w-1/3" data-id="element-670">
                      {label}
                    </th>
                    <td className="px-6 py-4 text-gray-700" data-id="element-671">{value}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>}

        {activeTab === 'Options' && <div className="space-y-6 text-gray-700" data-id="element-672">
            <div data-id="element-673">
              <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-674">
                4C Depot Color Options
              </h3>
              <p className="text-sm leading-relaxed" data-id="element-675">
                Choose from Dark Bronze, Black, Gold Speck, Postal Grey,
                Sandstone, Silver Speck, White, or Antique Bronze. The selected
                finish updates the product image so you can confirm the look
                before ordering.
              </p>
            </div>
            <div data-id="element-676">
              <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-677">
                Door Identification
              </h3>
              <p className="text-sm leading-relaxed" data-id="element-678">
                Select Standard Decal ID, Non Standard Decal ID, or Engraved -
                No Fill ID. This determines how each tenant door is labeled.
              </p>
            </div>
            <div data-id="element-679">
              <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-680">
                Door Sequence
              </h3>
              <p className="text-sm leading-relaxed" data-id="element-681">
                Standard number will be sequential if none entered. Use the
                project notes field to provide a custom numbering sequence or
                special requirements.
              </p>
            </div>
          </div>}

        {activeTab === 'PDFs / Downloads' && <div className="bg-white rounded-xl border border-brand-border p-6 text-gray-600" data-id="element-682">
            {/* TODO: wire to verified Website Forge product PDF assets */}
            <ul className="space-y-3 text-sm" data-id="element-683">
              <li className="flex items-center justify-between border-b border-brand-border/60 pb-3" data-id="element-684">
                <span className="font-medium text-brand-charcoal" data-id="element-685">
                  Product PDF
                </span>
                <span className="text-gray-400" data-id="element-686">
                  Pending Website Forge integration
                </span>
              </li>
              <li className="flex items-center justify-between" data-id="element-687">
                <span className="font-medium text-brand-charcoal" data-id="element-688">
                  PDF Line Drawings
                </span>
                <span className="text-gray-400" data-id="element-689">
                  Pending Website Forge integration
                </span>
              </li>
            </ul>
          </div>}

        {activeTab === 'Compatibility / USPS Notes' && <div className="bg-red-50 p-6 rounded-xl border border-red-200" data-id="element-690">
            <h3 className="text-brand-red font-bold mb-4" data-id="element-691">
              USPS Delivery Compliance
            </h3>
            <p className="text-red-900 mb-4" data-id="element-692">
              This freestanding Depot installation is{' '}
              <strong data-id="element-693">not approved for USPS Delivery</strong>. The Depot
              provides flexibility to install STD-4C wall-mounted mailboxes in a
              standalone cabinet for private delivery applications.
            </p>
            <p className="text-red-900" data-id="element-694">
              Confirm your delivery use and project requirements before
              ordering. If you require USPS delivery, shop our standard
              wall-mounted or pedestal-mounted CBU systems and consult your
              local Postmaster before installation.
            </p>
          </div>}

        {activeTab === 'Reviews' && <div className="p-6 text-center text-gray-600 border border-dashed border-brand-border rounded-xl" data-id="element-695">
            Nobody has rated this product yet.
          </div>}
      </div>
    </div>;
}